import React from 'react'
import { Link } from 'react-router-dom'
import ReestrRusApp from '../../Banner/ReestrRusApp'

type Props = {
    className?: string
}

export const MenuReestrLink: React.FC<Props> = ({ className }) => {
    return (
        <Link
            to="https://reestr.digital.gov.ru/reestr/3583882/"
            target="_blank"
            rel="noopener noreferrer"
            className={`flex-row items-center justify-start gap-1 group ${className}`}
        >
            <div className="w-10 h-10">
                <ReestrRusApp />
            </div>

            <div className="text-[12px] leading-none text-nowrap">
                <span className=" text-[#0a2b78] font-semibold">
                    В реестре Российского ПО
                </span>
                <br />
                <span className=" text-[#666666] group-hover:text-[#38bdf8] transition-colors duration-200">
                    Реестровая запись №29258
                </span>
            </div>
        </Link>
    )
}
